import React from 'react'
import Link from 'gatsby-link'

import { Toolbar, ToolbarTitle, IconButton, Shadow } from 'polythene-react'
const iconMenuSVG = (
  <svg
    fill="#000000"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
)
import { navigateTo } from 'gatsby-link'

const Header = () => (
  <div
    style={{
      position: 'relative',
      height: 64,
    }}
    className="w-100"
  >
    <Toolbar
      style={{
        backgroundColor: '#ffc107',
        height: 64,
      }}
    >
      <ToolbarTitle>
        <h3
          style={{
            height: 64,
            lineHeight: '64px',
          }}
        >
          <Link
            to="/"
            style={{
              color: 'black',
              textDecoration: 'none',
            }}
          >
            <img
              src="https://subfiresuite.com/pl/logos/SubFire-144t.png"
              style={{ display: 'inline-block', width: 'auto', height: 64 }}
            />
            <div
              style={{
                display: 'inline-block',
                height: 64,
                lineHeight: '64px',
                verticalAlign: 'text-bottom',
              }}
            >
              SubFire Suite
            </div>
          </Link>
        </h3>
      </ToolbarTitle>
      <IconButton
        url={{ onClick: () => navigateTo('/Updates') }}
        icon={{
          svg: iconMenuSVG,
        }}
      />
    </Toolbar>
    <Shadow />
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js